import { logger } from '@sentry/react';

const handleControllerChange = () => {
  // Delay reload to allow the pending network requests to complete
  setTimeout(() => {
    logger.warn(
      'New Service Worker has taken control. Reloading page to apply update and prevent mismatch errors.'
    );

    window.location.reload();
  }, 400);
};

export const listenToSWControllerChange = () => {
  if ('serviceWorker' in navigator) {
    logger.info('Service Worker controllerchange listener initialized.');

    navigator.serviceWorker.addEventListener(
      'controllerchange',
      handleControllerChange
    );
  }
};
